export default __webpack_public_path__ + "static/media/img_1.4dc4a8df.JPG";